import axios from '../../axios/instance';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import './auth.css';

export const LOGIN_CLINIC_REQUEST = 'LOGIN_CLINIC_REQUEST';
export const LOGIN_CLINIC_SUCCESS = 'LOGIN_CLINIC_SUCCESS';
export const LOGIN_CLINIC_FAILURE = 'LOGIN_CLINIC_FAILURE';
export const LOGOUT_CLINIC = 'LOGOUT_CLINIC';

export const logoutClinic = () => ({
  type: LOGOUT_CLINIC,
});

export const loginClinicRequest = () => ({
  type: LOGIN_CLINIC_REQUEST,
});

export const loginClinicSuccess = (data) => ({
  type: LOGIN_CLINIC_SUCCESS,
  payload: data,
});

export const loginClinicFailure = (error) => ({
  type: LOGIN_CLINIC_FAILURE,
  payload: error,
});

// export const loginClinic = (credentials) => {
//   return (dispatch) => {
//     dispatch(loginClinicRequest());
//     axios
//       .post('/account/login', credentials)
//       .then((response) => {
//         localStorage.setItem(
//           'name',
//           JSON.stringify(response.data.data.account)
//         );
//         localStorage.setItem('user', JSON.stringify(response.data.data.token));
//         localStorage.setItem(
//           'clinic',
//           JSON.stringify(response.data.data.account.clinics)
//         );
//         localStorage.setItem(
//           'selectedClinic',
//           JSON.stringify(response.data.data.account.clinics[0])
//         );
//         dispatch(loginClinicSuccess(response.data));
//         window.location.replace('/');
//       })
//       .catch((error) => {
//         const Toast = Swal.mixin({
//           toast: true,
//           position: 'bottom-start',
//           showConfirmButton: false,
//           timer: 3000,
//           timerProgressBar: true,
//           didOpen: (toast) => {
//             toast.addEventListener('mouseenter', Swal.stopTimer);
//             toast.addEventListener('mouseleave', Swal.resumeTimer);
//           },
//         });
//         Toast.fire({
//           icon: 'error',
//           title: !error.response
//             ? 'System sedang dalam perbaikan, silahkan coba beberapa saat lagi'
//             : error.response.data.error,
//         });
//       });
//   };
// };
